import {Directive, HostBinding, HostListener, Inject, input} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {ajs_$state_DI_TOKEN, AjsStateService} from "web-ng2/tjenester/ajs/AjsStateService";

const debug = initDebugger('AjsRouterLinkDirektiv');

/**
 * Direktiv som likner på Angular routerLink men delegerer navigasjonen til AngularJS StateService.
 *
 * Bruk dette direktivet for å navigere til AngularJS states fra Angular komponenter.
 *
 * Eksempler:
 * ```html
 * <a [ajsRouterLink]="'innhold.moete'" [ajsRouterLinkParams]="{id: moeteId}">Gå til møte</a>
 * <a [ajsRouterLink]="'innhold.dashboard'">Dashboard</a>
 * <button [ajsRouterLink]="'innhold.gruppe'" [ajsRouterLinkParams]="{gruppeId: gruppeId}">Åpne gruppe</button>
 * ```
 */
@Directive({
    selector: '[ajsRouterLink]'
})
export class AjsRouterLinkDirektiv {

    /** State-navn å navigere til */
    ajsRouterLink = input.required<string>();

    /** Parametere å sende til state */
    ajsRouterLinkParams = input<Record<string, any>>({});

    constructor(@Inject(ajs_$state_DI_TOKEN) private ajsStateService:AjsStateService) {
        this.ajsStateService = ajsStateService;
    }

    @HostBinding('attr.href')
    get href(): string | null {
        const stateName = this.ajsRouterLink();
        const params = this.ajsRouterLinkParams();

        if (!stateName) {
            return null;
        }

        try {
            return this.ajsStateService.href(stateName, params);
        } catch (e) {
            debug('Feil ved generering av href for state:', stateName, params, e);
            return null;
        }
    }

    @HostListener('click', ['$event'])
    onClick(event: MouseEvent): boolean {
        // Tillat standard oppførsel for ctrl/cmd/shift-click (åpne i ny tab osv)
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1) {
            return true;
        }

        const stateName = this.ajsRouterLink();
        const params = this.ajsRouterLinkParams();

        if (!stateName) {
            return true;
        }

        event.preventDefault();

        try {
            this.ajsStateService.go(stateName, params);
        } catch (e) {
            debug('Feil ved navigering til state:', stateName, params, e);
        }

        return false;
    }
}
